import { render } from "./cnpjExistente.vue?vue&type=template&id=0f9da03a&scoped=true"
import script from "./cnpjExistente.vue?vue&type=script&lang=js"
export * from "./cnpjExistente.vue?vue&type=script&lang=js"

import "./cnpjExistente.vue?vue&type=style&index=0&id=0f9da03a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9da03a"]])

export default __exports__